var app = angular.module("leonardo");

var WorkFlowInstanceDeleteList = function($scope, $state, $http, $q, $controller, WorkFlowInstanceService,
                                    DynamicFormRestService, FilterService) {
  $scope.workflows = [];
  $scope.workflows_account = [];
  $scope.tableFilterSize = 10;
  $scope.notEdit = true;

  $scope.by_unit = $state.current.by_unit;

  $scope.getEntitiesPromise = function (options) {
    var defer = $q.defer();
    options['by_unit'] = $scope.by_unit;
    if (FilterService.getFilter('account_reports')) {
      options['account'] = FilterService.getFilter('account_reports');
    }
    if (FilterService.getFilter('managed_by_reports')) {
      options['managed_by'] = FilterService.getFilter('managed_by_reports');
    }
    if (FilterService.getFilter('property_reports')) {
      options['property'] = FilterService.getFilter('property_reports');
    }
    if (FilterService.getFilter('portfolio_reports')) {
      options['portfolio'] = FilterService.getFilter('portfolio_reports');
    }
    if (FilterService.getFilter('search')) {
      options['search'] = FilterService.getFilter('search');
    }
    if (FilterService.getFilter('workflow_status')) {
      options['status'] = FilterService.getFilter('workflow_status');
    }
    if (!options['ordering']) {
      options['ordering'] = $scope.by_unit ? 'unit__building,unit__number,unit__name' : '-date_of_turn';
    }
    if (FilterService.getFilter('started_from_date')) {
      options['started_from_date'] = FilterService.getFilter('started_from_date');
    }
    if (FilterService.getFilter('started_to_date')) {
      options['started_to_date'] = FilterService.getFilter('started_to_date');
    }
    if (FilterService.getFilter('unit')) {
      options['unit'] = FilterService.getFilter('unit');
    }
    if (FilterService.getFilter('workflow')) {
      options['workflow'] = FilterService.getFilter('workflow');
    }

    WorkFlowInstanceService.getlist(options).then(function (list) {
      $scope.workflows = list.results ? list.results : list;
      $scope.groupForAccount($scope.workflows);
      defer.resolve($scope.workflows);
    }, function(error){
      defer.reject(error);
    });
    return defer.promise;
  };

  $scope.groupForAccount = function (elements) {
    $scope.workflows_account = [];
    angular.forEach(elements, function (element) {
       if ($scope.getIndex(element.account) < 0) {
         $scope.workflows_account.push({id: element.account, workflows: []});
       }
       $scope.workflows_account[$scope.getIndex(element.account)].workflows.push(element);
    });
  };

  $scope.getIndex = function(id) {
    var index = -1;
    angular.forEach($scope.workflows_account, function(value, key){
      if (value.id === id) {
        index = key;
      }
    });
    return index;
  };

  $controller('TableFilterController', { $scope: $scope });
};

app.controller('WorkFlowInstanceDeleteList', ['$scope', '$state', '$http', '$q', '$controller', 'WorkFlowInstanceService',
  'DynamicFormRestService', 'FilterService', WorkFlowInstanceDeleteList]);
